import {PeriodType} from 'modules/decisionsNext/api/types';
import {
  DateRangeFieldValue,
  DateRangeValueProps,
} from 'features/GlobalFilterProvider/filters/period/DateRangeItem/types';

import {RadioGroup} from 'components/RadioGroup';

const periodTypeOptions = [
  {
    label: 'YTD',
    value: PeriodType.Ytd,
  },
  {
    label: 'Rolling 12',
    value: PeriodType.Rolling_12Months,
  },
  {
    label: 'Custom',
    value: PeriodType.FromTo,
  },
];

export const PeriodTypeRadioGroup = ({value, updateValue}: DateRangeValueProps) => {
  return (
    <RadioGroup
      data-testid='filters-period-type-radio-group'
      row
      value={value.type}
      onChange={(_, type) =>
        updateValue({
          type: type as PeriodType,
          from: type === PeriodType.FromTo ? value.from : undefined,
          to: type === PeriodType.FromTo ? value.to : undefined,
        } satisfies DateRangeFieldValue)
      }
      options={periodTypeOptions}
    />
  );
};
